import * as React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { useFormik } from 'formik'
import { Col } from 'antd'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { UPDATE_BRAND_PROFILE } from '../../../../../mutations/UpdateBrandProfile'
import { client as apolloClient } from '../../../../ApolloProvider/ApolloProvider'
import { Brand as BrandType } from '../../../../../typings/types'
import DefaultButton from '../../../components/DefaultButton/DefaultButton'

import {
  PageTitle,
  WhiteBox,
  InputLabel,
  Input,
  ButtonWrapper,
  StyledRow,
} from '../../BrandDashboardSettings.style'

interface BrandSocialMediaFormProps {
  brandProfile?: BrandType
  brandOrderUuid?: string
}

const BrandSocialMediaForm: React.FC<BrandSocialMediaFormProps> = ({
  brandProfile,
  brandOrderUuid,
}) => {
  const [socialMediaInitialState, useSocialMediaInitialState] = React.useState({
    facebookPage: '',
    twitterName: '',
    linkedinPage: '',
    youtubeName: '',
  })

  React.useEffect(
    () => {
      useSocialMediaInitialState({
        facebookPage: (brandProfile && brandProfile.facebookPage) || '',
        twitterName: (brandProfile && brandProfile.twitterName) || '',
        linkedinPage: (brandProfile && brandProfile.linkedinPage) || '',
        youtubeName: (brandProfile && brandProfile.youtubeName) || '',
      })
    },
    [brandProfile]
  )

  const [updateBrandProfile, { loading: brandDetailsUpdating }] = useMutation(
    UPDATE_BRAND_PROFILE,
    {
      client: apolloClient,
    }
  )

  const socialMediaFormik = useFormik({
    initialValues: {
      ...socialMediaInitialState,
    },
    enableReinitialize: true,
    onSubmit: values => {
      updateBrandProfile({
        variables: {
          brandUuid: brandOrderUuid,
          brandUpdateInput: {
            facebookPage: values.facebookPage,
            twitterName: values.twitterName,
            linkedinPage: values.linkedinPage,
            youtubeName: values.youtubeName,
          },
        },
      })
    },
  })
  return (
    <>
      <PageTitle>Brand social media</PageTitle>
      <form onSubmit={socialMediaFormik.handleSubmit}>
        <WhiteBox>
          <StyledRow type="flex" gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>Facebook</InputLabel>
              <Input
                className={socialMediaFormik.values.facebookPage === '' ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="facebookPage"
                onChange={socialMediaFormik.handleChange}
                value={socialMediaFormik.values.facebookPage}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>Twitter</InputLabel>
              <Input
                className={socialMediaFormik.values.twitterName === '' ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="twitterName"
                onChange={socialMediaFormik.handleChange}
                value={socialMediaFormik.values.twitterName}
              />
            </Col>
          </StyledRow>
          <StyledRow type="flex" gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>LinkedIn</InputLabel>
              <Input
                className={socialMediaFormik.values.linkedinPage === '' ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="linkedinPage"
                onChange={socialMediaFormik.handleChange}
                value={socialMediaFormik.values.linkedinPage}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>YouTube</InputLabel>
              <Input
                className={socialMediaFormik.values.youtubeName === '' ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="youtubeName"
                onChange={socialMediaFormik.handleChange}
                value={socialMediaFormik.values.youtubeName}
              />
            </Col>
          </StyledRow>
          <ButtonWrapper>
            <DefaultButton
              fontSize="1rem"
              padding="0 1.625rem"
              backgroundColor={colors.adaptBlue}
              style={{ marginLeft: 'auto' }}
              type="submit"
              disabled={brandDetailsUpdating}
            >
              {brandDetailsUpdating ? 'Loading...' : 'Save changes'}
            </DefaultButton>
          </ButtonWrapper>
        </WhiteBox>
      </form>
    </>
  )
}

export default BrandSocialMediaForm



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/forms/BrandSocialMediaForm/BrandSocialMediaForm.tsx